import { Box, Label, Typography } from "@bca/ui-library";

import buildVehicleDetailsPageUrl from "../APICalls/buildVehicleDetailsPageUrl";
import { Vehicle } from "../Interfaces/vehicle.type";
import { HoverableLinkButton } from "../StyledComponents/HoverableLinkButton";
import CopyLabelWithTooltip from "./CopyLabelWithTooltip";
import vdpLinkDataPush from "../AdobeDataPushes/vehicleCard/vdpLinkDataPush";

interface PrimaryVehicleDetailsProps {
  vehicle: Vehicle;
}

const PrimaryVehicleDetails: React.FunctionComponent<
  PrimaryVehicleDetailsProps
> = ({ vehicle }) => {
  const isLink = vehicle.bidTimestamp && vehicle.inventoryId;
  const VDPUrl = buildVehicleDetailsPageUrl(
    { inventoryID: vehicle.inventoryId, filterDate: vehicle.bidTimestamp },
    vehicle.vrm
  );
  const vdpLinkDataPushHandler = () => vdpLinkDataPush(vehicle);

  return (
    <>
      <Box display="flex" flexDirection="row" mb={4} mx={4}>
        <CopyLabelWithTooltip infoToCopy={vehicle.vrm} labelCopied="VRM">
          <Label
            label={vehicle.vrm}
            backgroundColor="secondary-light-grey"
            textColor="grey-blue"
            fontWeight="bold"
            leftEdgeColor="primary-light-blue"
          />
        </CopyLabelWithTooltip>
        <CopyLabelWithTooltip
          infoToCopy={vehicle.lotNumber}
          labelCopied="Lot Number"
        >
          <Label
            label={vehicle.lotNumber}
            backgroundColor="rgba(241,241,241,1)"
            textColor="rgba(72, 88, 103, 1)"
            ml={4}
          />
        </CopyLabelWithTooltip>
      </Box>
      {isLink ? (
        <HoverableLinkButton
          variant="tertiary"
          shouldOpenInNewWindow={true}
          link={VDPUrl}
          onClick={vdpLinkDataPushHandler}
          text={vehicle.primaryVehicleDescription}
          fontSize={4}
          p={0}
          mx={5}
          mb={4}
        />
      ) : (
        <Typography
          variant="h5"
          color="footer-blue"
          m={0}
          mx={5}
          mb={4}
          css={`
            @media (max-width: 469px) {
              font-size: 16px;
            }
          `}
        >
          {vehicle.primaryVehicleDescription}
        </Typography>
      )}
    </>
  );
};

export default PrimaryVehicleDetails;
